import React from "react";
import { Link } from "react-router-dom";

const concerns = [
  { name: "Acne", image: "/images/concerns/acne.webp" , url: "/concerns/acne" },
  { name: "Blackheads", image: "/images/concerns/blackheads.webp", url: "/concerns/blackheads" },
  { name: "Tanning", image: "/images/concerns/tanning.webp" , url: "/concerns/tanning"},
  { name: "Dry Skin", image: "/images/concerns/dryskin.webp", url: "/concerns/dry-skin"  },
  { name: "Wrinkles", image: "/images/concerns/wrinkles.webp", url: "/concerns/wrinkles" },
  { name: "Oily Skin", image: "/images/concerns/oilyskin.webp", url: "/concerns/oily-skin"  },
];

const ShopByConcern = () => {
  return (
    <section className="my-6 sm:my-12 px-2 sm:px-4 text-center">
      <h2 className="text-xl mb-2  sm:text-3xl font-bold sm:mb-8">Shop by Concern</h2>
      <div className="grid grid-cols-6 gap-0.5 md:gap-6 justify-center items-center">
        {concerns.map((concern) => (
            <Link to={concern.url} key={concern.name} className="flex flex-col items-center hover:opacity-80">
                <img
              src={concern.image}
              alt={concern.name} aria-hidden="true" 
              className="w-18 sm:w-28 sm:h-28 md:w-36 md:h-36 rounded-full object-cover sm:border-black border-2"/>
                <p className="mt-1 sm:mt-2 sm:font-medium text-xs sm:text-base">{concern.name}</p>
            </Link>
        ))}
      </div>
    </section>
  );
};

export default ShopByConcern;
